import { create } from "zustand";

import type { UpgradeReason } from "@/config/plans";
import { loggerService, LogTag } from "@/Utils/LoggerService";

interface UpgradeStoreState {
  /** Why the action was refused, or null when no prompt is up. */
  quota: UpgradeReason | null;
  /**
   * Incremented on every open. The prompt uses it as a React `key` so a second
   * breach re-mounts (and therefore re-opens) the modal even when the previous
   * one was dismissed with the close icon.
   */
  openCount: number;
  openUpgrade: (quota: UpgradeReason) => void;
  closeUpgrade: () => void;
}

/**
 * Holds the quota breach that the API just refused an action for.
 *
 * `appFetch` fills it whenever the backend answers 402, so any blocked action
 * surfaces the same explanation without every page having to handle it.
 */
export const useUpgradeStore = create<UpgradeStoreState>((set) => ({
  quota: null,
  openCount: 0,

  openUpgrade: (quota) => {
    loggerService.info(LogTag.STORE, "UpgradeStore: openUpgrade");
    set((state) => ({ quota, openCount: state.openCount + 1 }));
  },

  closeUpgrade: () => {
    loggerService.info(LogTag.STORE, "UpgradeStore: closeUpgrade");
    set({ quota: null });
  },
}));
